import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import {handleLogout} from "../Utils/auth";
import API from '../Utils/api'
import {getUsuarioFromStorage} from "../Utils/usuarioHelper";
import DetalhamentoPedido from "../_Components/DetalhamentoPedido";
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';
import Cleave from "cleave.js/react"
import { Link } from 'react-router-dom';


export class BuscarCartela extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
        this.state = {
            pedidos: {},
            user: JSON.parse(localStorage.getItem("user")),
            clienteSelecionado: null,
            pedidoSelecionado: null,
            searched: []
        };
        this.selecionarPedido = this.selecionarPedido.bind(this)
        this.deselecionarPedido = this.deselecionarPedido.bind(this)
        this.getPedidoPorTransacao = this.getPedidoPorTransacao.bind(this)
    }

    deselecionarPedido(event) {
        this.setState({pedidoSelecionado: null, clienteSelecionado: null})
        this.forceUpdate()
    }

    selecionarPedido(event) {
        const pedido = JSON.parse(event.target.accessKey)
        this.setState({pedidoSelecionado: event.target.accessKey, clienteSelecionado: JSON.stringify(pedido.clienteId)})
        this.forceUpdate()
    }


    formatDate(data) {
    return moment(data).add(0,'days').format('DD-MM-YYYY')
    }
    

    listarPedidos = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("pedidos/buscar-por-cartela", {codigo : this.state.codigo});
            this.setState({searched: response.data});
            if(response.data.length == 0){
                alert("Cartela não encontrada!")
            }
        } catch (err) {
            console.log(err);
        }
    };

    async getPedidoPorTransacao(e) {
        try {
            const response = await API.post("/api/pedidos/por-transacao", {
                transacaoId: e._id
            });
            return response.data
        } catch (err) {
            console.log(err);
        }
    };

    searchCode(){
        var valor = document.getElementById('codigo').value;
        var filter  = [];
        this.state.pedidos.map(pedido => 
          {
             pedido.cartelas.filter(cartela => {
                if(!filter.includes(pedido) && cartela != undefined && cartela.codigo.includes(valor)){
                    filter.push(pedido)
                }
            })
          })

            this.setState({searched : filter})

    }


    setCodigo(e){
        this.setState({codigo: e.target.value})
    }

    render() {
        return (
            <MasterTemplate label={'Cartelas'}>
                <div onClick={this.deselecionarPedido} class="modal fade" id="exampleModalCenter" tabIndex="-1"
                     role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style={{maxWidth: '95vw', marginTop: '-8em'}}
                         role="document">
                        <div class="modal-content ">
                            <div class="modal-header">
                                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento
                                    pedido</h4>
                                <button onClick={this.deselecionarPedido} type="button" class="close"
                                        data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                {this.state.pedidoSelecionado ? <DetalhamentoPedido user={this.state.clienteSelecionado}
                                                                                    pedido={this.state.pedidoSelecionado}/> : ""}
                            </div>
                            <div class="modal-footer" style={{justifyContent: 'flex-end'}}>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">
                                        Buscador de cartelas
                                    </h4>
                                    <p className="card-category">O pedido será retornado.</p>
                                </div>
                                <div className="row mt-3 pl-5 pr-5">
                                <Cleave
                                                    data-length="7"
                                                    className={`form-control`}
                                                    options={{
                                                        numericOnly: true,
                                                        delimiters: ['-'],
                                                        blocks: [5,1]
                                                    }}
                                              
                                                    onChange={this.setCodigo.bind(this)}
                                                    placeholder="código 00000-0" 
                                                    style={{maxWidth: '10em'}}
                                            />
                                        {/* <input id="codigo" onChange={this.setCodigo.bind(this)} class="ml-5 form-control" style={{maxWidth: '10em'}} type="search" placeholder="código 00000-0"  aria-label="Search" /> */}
                                        {/* <input className="form-control" style={{maxWidth: '10em'}} placeholder="00000-0"></input> */}
                                        <button  onClick={this.listarPedidos}  className="ml-1 btn-fill btn btn-danger ">BUSCAR</button>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <table className="table table-hover table-striped">
                                        <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Codigo</th>
                                            <th>Cliente</th>
                                            <th>Vendedor</th>
                                            <th>Qtd de cartelas</th>
                                            <th>Valor total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.searched != null
                                            ? Object.entries(this.state.searched).map(
                                                (item, index) => {
                                                    return (
                                                        <tr
                                                            style={{cursor: 'pointer'}}
                                                            accessKey={JSON.stringify(item[1])}
                                                            data-toggle="modal"
                                                            data-target="#exampleModalCenter"
                                                            onClick={this.selecionarPedido}
                                                        >
                                                            <td accessKey={JSON.stringify(item[1])}>{this.formatDate(item[1].data)}</td>
                                                            <td accessKey={JSON.stringify(item[1])}>{item[1].codigo}</td>
                                                            <td accessKey={JSON.stringify(item[1])}>{item[1].clienteId ? item[1].clienteId.nome : "Desconhecido"}</td>
                                                            <td accessKey={JSON.stringify(item[1])}>{item[1].cambistaId ? item[1].cambistaId.nome : "Desconhecido"}</td>
                                                            
                                                            <td accessKey={JSON.stringify(item[1])}
                                                                className="pl-5">{item[1].cartelas ? item[1].cartelas.length : "0"}</td>
                                                            <td accessKey={JSON.stringify(item[1])}
                                                                className="pl-5">{item[1].cartelas[0] ? (item[1].cartelas.length * item[1].cartelas[0].valor).toFixed(2) : "0"}</td>
                                                        </tr>
                                                    );
                                                }
                                            )
                                            : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default BuscarCartela;
